<div class="flex items-center gap-3 w-full">
  <provider-portal-ask-ai-input class="grow min-w-0 max-w-3xl md:ml-4" />

  @if (telehealthCall.isOpen()) {
    <div class="ml-auto flex shrink-0 items-center gap-3">
      <icaredx-telehealth-live-control
        [patientName]="
          telehealthCall.activeAppointment()?.patientDisplayName ?? null
        "
        [mode]="telehealthCall.displayMode()"
        [unreadCount]="telehealthCall.unreadCount()"
        (modeChange)="telehealthCall.setDisplayMode($event)"
        (goToPatient)="goToPatientPage()" />
      <icaredx-dropdown-menu
        data-testid="header-actions"
        [vertical]="true"
        [menuItems]="headerMenuItems()"
        (actionEmitter)="onHeaderAction($event)" />
    </div>
  } @else {
    <div class="flex justify-end gap-3 shrink-0 ml-auto">
      <button
        type="button"
        data-testid="invite-patient"
        (click)="handleInvitePatient()"
        class="hidden sm:flex items-center justify-center px-3 py-2 text-sm font-medium text-primary-700 border border-primary-700 rounded-lg">
        <mat-icon class="h-3! w-3! mr-2" svgIcon="plus"></mat-icon>
        Invite patient
      </button>

      <button
        type="button"
        data-testid="new-appointment"
        [disabled]="loadingProvider()"
        (click)="openNewAppointmentDialog()"
        class="hidden sm:flex items-center justify-center px-3 py-2 text-xs font-bold text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 focus:outline-none cursor-pointer disabled:cursor-not-allowed disabled:opacity-50">
        <mat-icon class="h-3! w-3! mr-2" svgIcon="plus"></mat-icon>
        New Appointment
      </button>
    </div>

    <button
      type="button"
      (click)="openHelpCenterDialog()"
      class="hidden sm:flex items-center justify-center px-3 py-2 text-sm font-medium text-white bg-gray-900 hover:bg-gray-800 rounded-lg">
      <mat-icon class="h-3! w-3! mr-2" svgIcon="support"></mat-icon>
      Support
    </button>
  }
</div>
